/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Type_Return_FeeInputs */

const vi_customer_debt_type_return_fee = /** @type {(inputs: Customer_Debt_Type_Return_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phí trả hàng`)
};

/**

* @param {Customer_Debt_Type_Return_FeeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_type_return_fee = /** @type {((inputs?: Customer_Debt_Type_Return_FeeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Type_Return_FeeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_type_return_fee(inputs)
});